/**
 * Generated runtime TestId mirror for frontend/src/pages/InboundConnectors.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const InboundConnectorsTestIds = {
  colLastSync: "col-last-sync",
  colName: "col-name",
  colStatus: "col-status",
  colTargetSystem: "col-target-system",
  colType: "col-type",
  createInboundConnectorButton: "create-inbound-connector-button",
  inboundConnectorsList: "inbound-connectors-list",
  inboundConnectorsSkeleton: "inbound-connectors-skeleton",
  inboundConnectorsTable: "inbound-connectors-table",
  inboundConnectorName: (connector_id: string) => `inbound-connector-name-${connector_id}`,
  inboundConnectorNamePrefix: () => "inbound-connector-name-" as TestIdPrefix,
  inboundConnectorRow: (connector_id: string) => `inbound-connector-row-${connector_id}`,
  inboundConnectorRowPrefix: () => "inbound-connector-row-" as TestIdPrefix
} as const;
